import { z } from "zod";

export const schemaLogin = z
  .object({
    usroEmail: z.string().min(1,"Complete o campo corretamente"),
    usroSenha: z.string().min(1,"Complete o campo corretamente"),
  })
  
  export type LoginFormProps = z.infer<typeof schemaLogin>;
